Element.prototype.jsonData = function (key, value) {
    if (!key && !key.length) {
        return null;
    }

    if (!this._jsonDataSet) {
        this._jsonDataSet = {};

        if (value === undefined) {
            return null;
        }
    }

    if (value !== undefined) {
        this._jsonDataSet[key] = JSON.stringify(value);
        return value;
    }

    try {
        var data = this._jsonDataSet[key];
        if (data) {
            return JSON.parse(data);
        }
    }
    catch (ex) {
        console.error(`Unable to parse data for element ${this.id} key value ${key}`);
    }
    return null;
};

if (!window.Valinor) {

    window.Valinor = {

        init: function (options) {
            this._options = { ...this._defaultOptions };
            if (options) {
                this._options = { ...this._options, ...options };
            }
        },

        prepare: function (formId) {
            var form = document.querySelector(`#${formId}`);
            if (!form) {
                return null;
            }

            var inputs = form.querySelectorAll(`[data-validation-rules]`);
            if (inputs && inputs.length) {
                var formRules = {};
                inputs.forEach(input => {
                    input.jsonData('isPristine', true);
                    var inputData = JSON.parse(input.dataset.validationRules ?? '');
                    if (inputData && inputData.length) {
                        var inputRules = [];
                        var ruleExists = false;
                        inputData.forEach(inputDatum => {
                            if (inputDatum == 'required') {
                                inputRules.push({ type: 'required' });
                                ruleExists = true;
                            }

                            if (inputDatum == 'email') {
                                inputRules.push({ type: 'email' });
                                ruleExists = true;
                            }

                            if (inputDatum.indexOf('phone') >= 0) {
                                var split = inputDatum.split(':');
                                if (split && split.length > 1) {
                                    inputRules.push({
                                        type: 'phone',
                                        data: {
                                            country: split[1]
                                        }
                                    });
                                    ruleExists = true;
                                }
                            }

                            if (inputDatum.indexOf('minlength') >= 0) {
                                var split = inputDatum.split(':');
                                if (split && split.length > 1) {
                                    inputRules.push({
                                        type: 'minlength',
                                        data: {
                                            min: +split[1]
                                        }
                                    });
                                    ruleExists = true;
                                }
                            }

                            if (inputDatum.indexOf('maxlength') >= 0) {
                                var split = inputDatum.split(':');
                                if (split && split.length > 1) {
                                    inputRules.push({
                                        type: 'maxlength',
                                        data: {
                                            max: split[1]
                                        }
                                    });
                                    ruleExists = true;
                                }
                            }

                            if (inputDatum.indexOf('same') >= 0) {
                                var split = inputDatum.split(':');
                                if (split && split.length > 1) {
                                    inputRules.push({
                                        type: 'same',
                                        data: {
                                            id: split[1]
                                        }
                                    });
                                    ruleExists = true;
                                }
                            }

                            if (inputDatum.indexOf('custom') >= 0) {
                                var split = inputDatum.split(':');
                                if (split && split.length > 1) {
                                    inputRules.push({
                                        type: 'custom',
                                        data: {
                                            funcName: split[1]
                                        }
                                    });
                                    ruleExists = true;
                                }
                            }
                        });

                        if (ruleExists) {
                            input.jsonData('rules', inputRules);
                            formRules[input.id] = inputRules;
                        }
                    }
                });
                if (formRules) {
                    form.jsonData('validationSettings', formRules);
                }
                return formRules;
            }
            return null;
        },

        validate: function (formId) {
            var form = document.querySelector(`#${formId}`);
            if (!form) {
                return true;
            }

            var settings = form.jsonData('validationSettings');
            if (!settings) {
                settings = this.prepare(formId);
                if (!settings) {
                    return true;
                }
            }

            var valid = true;
            for (const [id, rules] of Object.entries(settings)) {
                if (!id || !rules || !rules.length) {
                    continue;
                }

                var input = document.getElementById(id);
                if (!input) {
                    continue;
                }

                if (!this.validateField(input, rules)) {
                    valid = false;
                }
            }

            return valid;
        },

        validateField: function (input, rules) {
            var length = rules.length;
            for (var i = 0; i < length; i++) {
                var rule = rules[i];
                if (!rule || !rule.type || !rule.type.length) {
                    continue;
                }

                var validator = this._validators[rule.type];
                if (!validator) {
                    console.error(`Validator not found for rule type ${rule.type}.`);
                    continue;
                }

                var container = input.closest('.js-input-container');
                if (!container) {
                    console.error(`Container not found for input ${input.id}`);
                    continue;
                }

                var inputValue = this.fieldValue(input);
                var valid = validator.handler(inputValue, rule.data);
                if (!valid) {
                    var message = container.querySelector('.js-input-error-message');
                    if (!message) {
                        console.error(`Cannot display error message for input ${input.id}`);
                        continue;
                    }

                    var errorMessage = validator.message(rule.data);
                    const tempDecoder = document.createElement('textarea');
                    tempDecoder.innerHTML = errorMessage;
                    message.innerText = tempDecoder.value;
                    if (input.dataset.validationDisplay == 'custom') {
                        if (!this._options.customDisplayHandlers) {
                            console.error('No customDisplayHandlers availables, you should create a var named customDisplayHandlers in the context to declare custom display handlers');
                        }
                        var handler = this._options.customDisplayHandlers[input.id];
                        if (!handler) {
                            console.error(`No custom display handler found for input ${input.id}`);
                        }
                        handler.invalid(input, container, this._options.invalidClasses);
                    }
                    else {
                        input.classList.add(...this._options.invalidClasses);
                    }
                    container.querySelectorAll('.js-input-invalid').forEach(element => {
                        element.classList.remove('hidden');
                    });
                    return false;
                }
                else {
                    if (input.dataset.validationDisplay == 'custom') {
                        if (!this._options.customDisplayHandlers) {
                            console.error('No customDisplayHandlers availables, you should create a var named customDisplayHandlers in the context to declare custom display handlers');
                        }
                        var handler = this._options.customDisplayHandlers[input.id];
                        if (!handler) {
                            console.error(`No custom display handler found for input ${input.id}`);
                        }
                        handler.valid(input, container, this._options.invalidClasses);
                    }
                    else {
                        input.classList.remove(...this._options.invalidClasses);
                    }
                    container.querySelectorAll('.js-input-invalid').forEach(element => {
                        element.classList.add('hidden');
                    });
                }
            }
            return true;
        },

        fieldValue: function (field) {
            var type = field.getAttribute('type');
            switch (type) {
                case 'checkbox': {
                    if (field.checked) {
                        return field.value;
                    }
                    return null;
                }
                case 'radio': {
                    var name = field.getAttribute('name');
                    var checked = null;
                    document.querySelectorAll(`input[name="${name}"]`).forEach(element => {
                        if (element.checked) {
                            checked = element;
                        }
                    });
                    if (checked) {
                        return checked.value;
                    }
                    return null;
                }
                default: return field.value;
            }
        },

        message: function (rule, data) {
            if (this._options && this._options.customValidatorMessageHandlers) {
                var handler = this._options.customValidatorMessageHandlers[rule];
                if (handler) {
                    return handler.call(undefined, data);
                }
            }
            return null;
        },

        _options: {},
        _defaultOptions: {
            invalidClasses: ['bg-error', '!border-error', '!pr-8'],
            customDisplayHandlers: null,
            customValidatorMessageHandlers: null
        },

        _validators: {
            required: {
                handler: (value) => {
                    return value && value.trim().length;
                },
                message: () => {
                    return Valinor.message('required') ?? 'This field is required.';
                }
            },
            email: {
                handler: (value) => {
                    return value && value.length && /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi.test(value);
                },
                message: () => {
                    return Valinor.message('email') ?? 'A valid email address is required.';
                }
            },
            phone: {
                handler: (value, data) => {
                    if (!value && !value.length) {
                        return true
                    }
                    if (!libphonenumber) {
                        console.error('Missing dependency library libphonenumber.');
                        return value && value.length;
                    }
                    return libphonenumber.isValidPhoneNumber(value, data.country);
                },
                message: () => {
                    return Valinor.message('phone') ?? 'A valid phone number is required.';
                }
            },
            minlength: {
                handler: (value, data) => {
                    return value && value.trim().length && value.trim().length >= data.min;
                },
                message: (data) => {
                    return Valinor.message('minlength', data) ?? 'At least {0} characters required.'.replaceAll('{0}', data.min);
                }
            },
            maxlength: {
                handler: (value, data) => {
                    if (value) {
                        return value.length && value.length <= data.max;
                    } else {
                        return true;
                    }
                },
                message: (data) => {
                    return Valinor.message('maxlength', data) ?? 'Max {0} characters.'.replaceAll('{0}', data.max);
                }
            },
            same: {
                handler: (value, data) => {
                    var reference = document.querySelector(`#${data.id}`).value;
                    return value && value.length && reference && reference.length && reference === value;
                },
                message: (data) => {
                    return Valinor.message('same', data) ?? 'Both values should be the same';
                }
            },
            custom: {
                handler: (value, data) => {
                    var customHandler = eval(`${data.funcName}()`);
                    if (!customHandler) {
                        console.error(`No custom handler for function name ${data.funcName}.`);
                        return false;
                    }
                    return customHandler.handler(value, data);
                },
                message: (data) => {
                    var customHandler = eval(`${data.funcName}()`);
                    if (!customHandler) {
                        console.error(`No custom handler for function name ${data.funcName}.`);
                        return 'Something is not valid here.';
                    }
                    return customHandler.message(data);
                }
            }
        }
    };
}

document.addEventListener("DOMContentLoaded", () => {

    function applyValidationRules(event) {
        var input = event.target;
        if (!input || input.jsonData('isPristine')) {
            return true;
        }

        var rules = input.jsonData('rules');
        if (!rules || !rules.length) {
            return true;
        }

        Valinor.validateField(input, rules);

        var sameRule = rules.filter(x => x.type == 'same')[0];
        if (sameRule && sameRule.data && sameRule.data.id) {
            linkedInput = document.querySelector(`#${sameRule.data.id}`);
            if (linkedInput) {
                linkedRules = linkedInput.jsonData('rules');
                if (linkedRules) {
                    Valinor.validateField(linkedInput, linkedRules);
                }
            }
        }
    }

    document.querySelectorAll(`[data-validation-rules]`).forEach(element => {
        element.addEventListener('blur', (event) => {
            var input = event.target;
            if (!input) {
                return true;
            }

            input.jsonData('isPristine', false);
            applyValidationRules(event);
        });

        ['blur', 'input', 'change'].forEach(e => {
            element.addEventListener(e, applyValidationRules);
        });
    });
});